mutation deleteMarketingPlanSlots($input: DeleteSlotsInput!) {
  results: deleteMarketingPlanSlots(input: $input) {
    slotId
    outcome
    code
    reason
  }
}
